// extracted by mini-css-extract-plugin
export default {"root":"FavoriteButton_root__17Akw","icon":"FavoriteButton_icon__fLSdN","active":"FavoriteButton_active__S2ZII"};